import {Component, HostBinding, OnInit} from '@angular/core';
import {AdalService} from "adal-angular4";
import {SettingsProvider} from "../../core";

@Component({
    selector: 'pr-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow';

    constructor(
        public adal: AdalService,
        private settingsService: SettingsProvider,
    ) {
    }

    ngOnInit(): void {

    }

    public login(): void {
        this.adal.login();
    }

}
